<template>
  <div
    class="div-ajuda"
    @mouseover="mostrarTexto"
    @mouseout="esconderTexto"
  >
    <img
      src="@/assets/fotoAjuda.png"
      height="20px"
      width="20px"
      alt="Ajuda"
    />
    <p
      v-if="mostrar"
      class="text-ajuda"
    >
      {{ texto }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    mostrarTexto() {
      this.mostrar = true;
    },
    esconderTexto() {
      this.mostrar = false;
    },
  },
};
</script>

<style scoped>
.div-ajuda {
  position: relative;
  display: inline-flex;
  margin-left: 8px;
  cursor: pointer;
}

.text-ajuda {
  position: absolute;
  background-color: #834fab;
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
  left: 50%;
  transform: translateX(-105%);
  width: 30vw;
  box-shadow: 0 2px 10px #834fab;
  z-index: 100;
}
</style>
